import { valueIsNotNullOrUndefined } from '@afterpay/utils'
import { DataDogUserProps } from '.'
import { RumInitConfiguration } from '@datadog/browser-rum'

export const hasValidDatadogKeys = (DATADOG_APP_ID?: string, DATADOG_CLIENT_TOKEN?: string, DATADOG_SERVICE?: string): boolean => {
  const hasDatadogAppId = typeof DATADOG_APP_ID !== 'undefined' && DATADOG_APP_ID.length > 0
  const hasDatadogClientToken = typeof DATADOG_CLIENT_TOKEN !== 'undefined' && DATADOG_CLIENT_TOKEN.length > 0
  const hasDatadogService = typeof DATADOG_SERVICE !== 'undefined' && DATADOG_SERVICE.length > 0
  return hasDatadogAppId && hasDatadogClientToken && hasDatadogService
}

export const hasUserProperties = (userProperties?: DataDogUserProps): boolean => {
  const { consumerCountryCode, merchantCountryCode, uuid } = userProperties ?? {}
  return valueIsNotNullOrUndefined(consumerCountryCode) && valueIsNotNullOrUndefined(merchantCountryCode) && valueIsNotNullOrUndefined(uuid)
}

// Discard RUM errors that are of report type only
// https://block.atlassian.net/browse/CHECKOUT-4571?focusedCommentId=8411303
export const beforeRumSend: NonNullable<RumInitConfiguration['beforeSend']> = (event, context): boolean => {
  if (event.type === 'error') {
    if (typeof event.error.csp !== 'undefined' && event.error.csp.disposition === 'report') {
      return false
    }

    const regex = /Serialiser failed/

    if (regex.test(event.error.message)) {
      return false
    }
  }

  return true
}
